/* eslint-disable import/no-cycle */
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from '@axios'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import masterData from './routes/master-data'
import setting from './routes/setting'
import accounting from './routes/accounting'
import toko from './routes/toko'
import workshop from './routes/workshop'
import dashboard from './routes/dashboard'
import others from './routes/others'
import pages from './routes/pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard-toko' } },
    ...apps,
    ...masterData,
    ...toko,
    ...workshop,
    ...dashboard,
    ...others,
    ...accounting,
    ...setting,
    ...pages,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// router.beforeEach((to, _, next) => {
//   const isLoggedIn = isUserLoggedIn()

//   if (!canNavigate(to)) {
//     // Redirect to login if not logged in
//     if (!isLoggedIn) return next({ name: 'auth-login' })

//     // If logged in => not authorized
//     return next({ name: 'misc-not-authorized' })
//   }

//   // Redirect if logged in
//   if (to.meta.redirectIfLoggedIn && isLoggedIn) {
//     const userData = getUserData()
//     next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
//   }

//   return next()
// })

// ? For splash screen
// Remove afterEach hook if you are not using splash screen

router.beforeEach(async (to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'auth-login' })
    return next({ name: 'misc-not-authorized' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  // === Cek status toko ===
  if (isLoggedIn && to.name !== 'setting-close-store') {
    const today = new Date().toISOString().split('T')[0]
    const statusKey = 'storeClosed'
    const lastCheck = localStorage.getItem(statusKey)

    if (lastCheck !== today) {
      try {
        const { data } = await axios.get('/closing/cash/check')
        console.log('Status toko:', (data.exists))

        if (data.exists) {
          localStorage.setItem(statusKey, today)
        } else {
          return next({ name: 'setting-close-store' }) // ganti dengan route name halaman tutup toko
        }
      } catch (error) {
        console.error('Gagal cek status toko', error)
        // Bisa di-handle redirect atau biarkan lewat
      }
    }
  }

  return next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
